import AcxChip from "components/UI/AcxChip";
import { observer } from "mobx-react";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "../Stores/LLMClassifierBuilderStore";
import React from "react";

type LabeledConversationsChipProps = {
    result: string;
};

export const LabeledConversationsChip = observer(function (
    props: LabeledConversationsChipProps,
) {
    const store = useStore(LLMClassifierBuilderStore);

    // What an agreement test can use: human labels, then synthetic calls.
    const counts = store.agreementTestCountsByResult?.get(props.result) ?? {
        human: 0,
        synthetic: 0,
    };
    if (!store.agreementTestCountsByResult) return null;

    const label = `${store.dataLabelingModule?.name} > ${
        store.dataLabelingQuestion?.questionText
    } > ${props.result}: ${counts.human} human + ${counts.synthetic} synthetic`;

    return (
        <AcxChip
            size="small"
            color="lightBlue"
            wrapTooltip
            customTooltip={label}
            style={{ textWrap: "wrap", maxWidth: "50dvw" }}
            label={label}
        />
    );
});
